export default {"src":"/_next/static/media/XOM.d65d1948.svg","height":18,"width":18};